// components/ui/LoginModal.js
import React from 'react';
import { createPortal } from 'react-dom';
import { useLanguage } from '../../context/LanguageContext';
import { useApp } from '../../context/AppContext';
import '../../styles/loginModal.css';

const LoginModal = ({ isOpen, onClose }) => {
    const { language } = useLanguage();
    const { login } = useApp();

    if (!isOpen || typeof document === 'undefined') return null;

    const handleLogin = () => {
        login();
        onClose();
    };

    return createPortal(
        <div className="login-modal-overlay" onClick={onClose}>
            <div className="login-modal-content" onClick={(e) => e.stopPropagation()}>
                <button 
                    className="login-modal-close"
                    onClick={onClose}
                    aria-label={language === 'it' ? 'Chiudi' : 'Close'}
                >
                    <span className="material-icons">close</span>
                </button>

                <div className="login-modal-icon">
                    <img src="/img/ok.jpg" alt="Foundly" className="login-modal-image" />
                </div>

                <h2 className="login-modal-title">
                    {language === 'it' 
                        ? 'Salva i tuoi artisti preferiti' 
                        : 'Save your favorite artists'}
                </h2>

                <p className="login-modal-message">
                    {language === 'it'
                        ? 'Accedi con Google per salvare i tuoi artisti preferiti e accedervi da qualsiasi dispositivo.'
                        : 'Sign in with Google to save your favorite artists and access them from any device.'}
                </p>

                <button 
                    className="login-modal-button"
                    onClick={handleLogin}
                >
                    <svg width="18" height="18" viewBox="0 0 18 18" style={{ marginRight: '8px' }}>
                        <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"/>
                        <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.96-2.184l-2.908-2.258c-.806.54-1.837.86-3.052.86-2.347 0-4.33-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z"/>
                        <path fill="#FBBC05" d="M3.964 10.712c-.18-.54-.282-1.117-.282-1.712 0-.595.102-1.172.282-1.712V4.956H.957C.348 6.175 0 7.55 0 9s.348 2.825.957 4.044l3.007-2.332z"/>
                        <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.582C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.956L3.964 7.288C4.67 5.163 6.653 3.58 9 3.58z"/>
                    </svg>
                    {language === 'it' ? 'Accedi con Google' : 'Sign in with Google'}
                </button>

                <p className="login-modal-footer">
                    {language === 'it'
                        ? 'I tuoi dati sono al sicuro e privati.'
                        : 'Your data is safe and private.'}
                </p>
            </div>
        </div>
    , document.body);
};

export default LoginModal;

